import { render } from "./StandardTexts.vue?vue&type=template&id=d653e128"
import script from "./StandardTexts.vue?vue&type=script&lang=js"
export * from "./StandardTexts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__